// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"price":{"f":""},"estimatedCompletion":{"b":""},"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

let Utils = {};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentProjectSearchResult_developmentProject",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "developer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalProjectUnits",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "estimatedCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": [
            {
              "kind": "Literal",
              "name": "priceFormat",
              "value": "FULL"
            },
            {
              "kind": "Literal",
              "name": "priceRangeFormat",
              "value": "SHORT"
            }
          ],
          "kind": "FragmentSpread",
          "name": "PropertyPrice_propertyPrice"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentProjectSearchResultCard_developmentProject"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentProjectSearchResultTitleAndLocation_developmentProject"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentProjectSearchResultAgent_developmentProject"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentProjectSearchResultTimestamp_developmentProject"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentProjectSearchResultActions_developmentProject"
    }
  ],
  "type": "DevelopmentProject",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
